export default "__VITE_ASSET__CSt_RCqC__"